import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query"
import { RouterProvider, createRouter } from "@tanstack/react-router"
import ReactDOM from "react-dom/client"
import { routeTree } from "./routeTree.gen"

import { client } from "./client/client.gen"
import { CustomProvider } from "./components/ui/provider"
import { StrictMode } from "react"
import { clearAuthState, getStoredAccessToken } from "./utils/auth"

client.setConfig({
  baseUrl: import.meta.env.VITE_API_URL,
  throwOnError: true,
  responseStyle: "data",
})

client.interceptors.request.use((request: any) => {
  const token = getStoredAccessToken()
  if (token) {
    request.headers.set("Authorization", `Bearer ${token}`)
  }
  return request
})

const handleApiError = (error: unknown) => {
  if (!(error instanceof Error)) return
  const res = (error as any).response as Response | undefined
  if (!res) return

  const isLoginRequest = res.url?.includes("/login/access-token")
  if (isLoginRequest && res.status === 401) return

  if ([401, 403].includes(res.status)) {
    clearAuthState()
    window.location.href = "/login"
  }
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: handleApiError,
  }),
  mutationCache: new MutationCache({
    onError: handleApiError,
  }),
})

const router = createRouter({ routeTree })
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <CustomProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </CustomProvider>
  </StrictMode>,
)
